// import React, { useState, useEffect } from "react";
// import { useHistory } from 'react-router-dom';
// import { connect } from "react-redux";
// import axios from "axios";
// import { NavLink } from "react-bootstrap";
// import ConfirmDeleteModal from './ConfirmationModelDelete';
// import { saveAs } from 'file-saver';
// import { Parser } from 'json2csv';
// const token = localStorage.getItem('authToken');
// const DonationList = () => {
//   const [categories, setCategories] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [searchQuery, setSearchQuery] = useState({ address: "", pincode: "" });
//   const [showModal, setShowModal] = useState(false);
//   const [selectedCategoryId, setSelectedCategoryId] = useState(null);
//   const history = useHistory();

//   const getData = async () => {
//     try {
//       const response = await axios.get(`https://samaj.aasmo.in/api/admin/donation`, {
//         params: {
//           page: currentPage,
//           title: searchQuery.title,
         
//         },
//     }, {  
//     headers: {
//       Authorization: `Bearer ${token}`, 
//   }});
//       setCategories(response.data.donations);
//       setTotalPages(response.data.totalPages);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleEdit = (id) => {
//     history.push(`/editdonation/${id}`);
//   };

//   const handleDelete = async (id) => {
//     try {
//       const response = await axios.delete(`https://samaj.aasmo.in/api/admin/donation/${id}`,{
//         headers: {
//           Authorization: `Bearer ${token}`, 
//       }
//       });
//       if (response) {
//         console.log("Deleted Successfully");
//         getData();
//       }
//     } catch (error) {
//       console.log(error);
//     }
//     setShowModal(false);
//   };

//   const handleDeleteClick = (id) => {
//     setSelectedCategoryId(id);
//     setShowModal(true);
//   };

//   useEffect(() => {
//     getData();
//   }, [currentPage, searchQuery]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//   };

//   const handleSearchChange = (e) => {
//     setSearchQuery({
//       ...searchQuery,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleDownload = () => {
//     const fields = [
//       "id", "title","image","description","createdAt"
//   ];
//   const json2csvParser = new Parser({ fields });
//   const csv = json2csvParser.parse(categories);
//   const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//     saveAs(blob, 'donation_list.csv');
// }


// const formatDate = (dateString) => {
//     const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
//     return new Date(dateString).toLocaleDateString(undefined, options);
// };
// const formatDescription = (description) => {
//   return description.length > 10 ? description.slice(0, 10) + '...' : description;
// };
//   return (
//     <div className="col-lg-12">
//       <div className="card">
//         <div className="header">
//           <h2>Donation List</h2>
//         </div>
//         <div className="d-flex justify-content-start">
//           <div className="input-group m-b-10 col-lg-6">
//             <div className="input-group-prepend">
//               <span className="input-group-text">
//                 <i className="icon-magnifier"></i>
//               </span>
//             </div>
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Search By Title"
//               name="title"
//               value={searchQuery.title}
//               onChange={handleSearchChange}
//             />
          
//           </div>
//           <div>
//           <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
//           </div>
//         </div>
//         <div className="body table-responsive">
//           <table className="table table-hover">
//             <thead>
//               <tr>
//                 <th>S.No</th>
//                 <th>Title</th>
//                 <th>Images</th>
//                 <th>Description</th>
//                 <th>Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody >
//               {categories.map((category, index) => {
//                 return (
//                   <tr key={category.id}>
//                     <td>{(currentPage - 1) * 10 + index + 1}</td>
//                     <td>{category.title}</td>
//                     <td>
//                       <img src={`https://uma-classees.blr1.digitaloceanspaces.com/${category.image}`} width={50} height={50} className="rounded-circle user-photo" alt="Category" />
//                     </td>
                  
                  
//                     <td>{formatDescription(category.description)}</td>
//                     <td> {formatDate(category.createdAt)}</td>
//                     <td>
//                       <i className="icon-pencil" onClick={() => handleEdit(category.id)}></i>
//                       &nbsp;&nbsp;
//                       <i className="fa fa-trash-o" onClick={() => handleDeleteClick(category.id)}></i>
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         </div>
//         <div className="body">
//           <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
//             <ul className="pagination">
//               <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage - 1)}
//                 >
//                   Previous
//                 </NavLink>
//               </li>
//               {[...Array(totalPages).keys()].map(page => (
//                 <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
//                   <NavLink
//                     to="#"
//                     className="page-link"
//                     onClick={() => handlePageChange(page + 1)}
//                   >
//                     {page + 1}
//                   </NavLink>
//                 </li>
//               ))}
//               <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
//                 <NavLink
//                   to="#"
//                   className="page-link"
//                   onClick={() => handlePageChange(currentPage + 1)}
//                 >
//                   Next
//                 </NavLink>
//               </li>
//             </ul>
//           </nav>
//         </div>
//       </div>
//       <ConfirmDeleteModal
//         show={showModal}
//         handleClose={() => setShowModal(false)}
//         handleConfirm={() => handleDelete(selectedCategoryId)}
//       />
//     </div>
//   );
// };

// const mapStateToProps = ({ mailInboxReducer }) => ({});

// export default connect(mapStateToProps, {})(DonationList);


import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import axios from "axios";
import { NavLink } from "react-bootstrap";
import ConfirmDeleteModal from './ConfirmationModelDelete';
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';

// Get token once outside the component if it's static after initial load
const token = localStorage.getItem('authToken');

const DonationList = () => {
  // Renamed to 'donations' for clarity, but keeping original variable name 'categories' to match your code structure
  const [categories, setCategories] = useState([]); 
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  // Initializing searchQuery with only 'title' as that's what's used in API params
  const [searchQuery, setSearchQuery] = useState({ title: "" }); 
  const [showModal, setShowModal] = useState(false);
  // Renamed to 'selectedDonationId' for clarity
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); 
  const history = useHistory();

  const getData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/donation`, {
        // Corrected Axios config: params and headers should be in the same object
        params: {
          page: currentPage,
          title: searchQuery.title, // Ensure this matches your backend's expected query param for title
        },
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      setCategories(response.data.donations);
      setTotalPages(response.data.totalPages);
      // IMPORTANT: Log the fetched data to inspect the 'image' property structure
      console.log("Fetched donations data:", response.data.donations); 
    } catch (error) {
      console.error("Error fetching donations:", error); // Use console.error for better error reporting
    }
  };

  const handleEdit = (id) => {
    history.push(`/editdonation/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`https://samaj.aasmo.in/api/admin/donation/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      if (response.status === 200) { // Check for a successful status code like 200 OK
        console.log("Donation Deleted Successfully");
        getData(); // Refresh data after successful deletion
      } else {
        console.warn("Delete request did not return success status:", response);
      }
    } catch (error) {
      console.error("Error deleting donation:", error); // Use console.error
    } finally {
      setShowModal(false); // Ensure modal is closed regardless of success or failure
    }
  };

  const handleDeleteClick = (id) => {
    setSelectedCategoryId(id); // Using the original state variable name
    setShowModal(true);
  };

  useEffect(() => {
    // Add token to dependencies to re-fetch if token changes (though unlikely in current setup)
    getData();
  }, [currentPage, searchQuery.title, token]); 

  const handlePageChange = (page) => {
    // Ensure the page number is valid before setting
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery({
      ...searchQuery,
      [e.target.name]: e.target.value
    });
    setCurrentPage(1); // Reset to the first page when search query changes
  };

  const handleDownload = () => {
    const fields = [
      "id", "title","image","description","createdAt"
    ];
    try {
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(categories); // 'categories' holds the donations data
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        saveAs(blob, 'donation_list.csv');
    } catch (err) {
        console.error('Error generating CSV:', err);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle cases where dateString might be null/undefined
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const formatDescription = (description) => {
    if (!description) return ''; // Handle cases where description might be null/undefined
    return description.length > 50 ? description.slice(0, 50) + '...' : description; // Increased slice length for better readability
  };

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="header">
          <h2>Donation List</h2>
        </div>
        <div className="d-flex justify-content-start flex-wrap align-items-center"> {/* Added flex-wrap and align-items-center */}
          <div className="input-group m-b-10 col-lg-6 col-md-6 col-sm-12"> {/* Added responsive classes */}
            <div className="input-group-prepend">
              <span className="input-group-text">
                <i className="icon-magnifier"></i>
              </span>
            </div>
            <input
              type="text"
              className="form-control"
              placeholder="Search By Title"
              name="title" // Ensure name matches the property in searchQuery state
              value={searchQuery.title}
              onChange={handleSearchChange}
            />
          </div>
          <div className="m-b-10 ml-auto mr-3"> {/* Moved download button to the right */}
            <button className="btn btn-primary" onClick={handleDownload}>Download CSV</button>
          </div>
        </div>
        <div className="body table-responsive">
          <table className="table table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Images</th>
                <th>Description</th>
                <th>Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? ( // Check if there are any donations to display
                categories.map((donation, index) => { // Renamed 'category' to 'donation' for clarity
                  let finalImageUrl;
                  if (donation.image) {
                      // Check if it's already a full URL (e.g., "https://...")
                      if (donation.image.startsWith('http://') || donation.image.startsWith('https://')) {
                          finalImageUrl = donation.image;
                      } else {
                          // Otherwise, prepend the S3 base URL
                          finalImageUrl = `https://uma-classees.blr1.digitaloceanspaces.com/${donation.image}`;
                      }
                  }

                  return (
                    <tr key={donation.id}>
                      <td>{(currentPage - 1) * 10 + index + 1}</td>
                      <td>{donation.title}</td>
                      <td>
                        {/* Image display with robust fallback and error handling */}
                        {finalImageUrl ? (
                          <img 
                            src={finalImageUrl} 
                            width={50} 
                            height={50} 
                            className="rounded-circle user-photo" 
                            alt={donation.title || "Donation Image"} // Better alt text
                            onError={(e) => {
                              e.target.onerror = null; // Prevent infinite loop if placeholder also fails
                              e.target.src = 'https://via.placeholder.com/50?text=Error'; // Generic placeholder on error
                              console.warn(`Failed to load image for donation "${donation.title}". URL: ${finalImageUrl}`);
                            }}
                          />
                        ) : (
                          // Placeholder if image path is not provided by API
                          <img 
                            src="https://via.placeholder.com/50?text=No+Image" 
                            width={50} 
                            height={50} 
                            className="rounded-circle user-photo" 
                            alt="No Image Available" 
                          />
                        )}
                      </td>
                      <td>{formatDescription(donation.description)}</td>
                      <td> {formatDate(donation.createdAt)}</td>
                      <td>
                        <i className="icon-pencil" onClick={() => handleEdit(donation.id)} style={{ cursor: 'pointer' }}></i>
                          
                        <i className="fa fa-trash-o" onClick={() => handleDeleteClick(donation.id)} style={{ cursor: 'pointer' }}></i>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No donations found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="body">
          <nav aria-label="Page navigation example" style={{ display: 'flex', justifyContent: 'center' }}>
            <ul className="pagination">
              <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </NavLink>
              </li>
              {[...Array(totalPages).keys()].map(page => (
                <li key={page} className={`page-item ${currentPage === page + 1 ? 'active' : ''}`}>
                  <NavLink
                    to="#"
                    className="page-link"
                    onClick={() => handlePageChange(page + 1)}
                  >
                    {page + 1}
                  </NavLink>
                </li>
              ))}
              <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                <NavLink
                  to="#"
                  className="page-link"
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <ConfirmDeleteModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        handleConfirm={() => handleDelete(selectedCategoryId)}
      />
    </div>
  );
};

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(DonationList);